// Starter forms for the builder's Examples menu. The first one is also the
// default document for anonymous visitors without a saved draft.

export const EXAMPLES = [
  {
    id: 'rsvp',
    title: 'Event RSVP',
    description: 'Pages, a branch and most question types.',
    source: `---
title: DevConf RSVP
description: Tell us whether you're coming, and what you'd like to see.
submit: Send RSVP
confirmation: Thanks, see you there!
---

Intro text is **plain Markdown** and becomes a content block.

? Full name *
___

? Email * {#email}
> We'll only use this for event updates.
[email]

? Will you attend? *
- ( ) Yes
- ( ) No -> #bye

? Which days?
- [ ] Day 1
- [ ] Day 2
- [ ] Other: ___

? T-shirt size
[select]
- S
- M
- L

? How excited are you?
[scale 1..5 "Meh" "Very"]

? Which sessions will you join?
[grid]
|          | Yes {yes} | Maybe {maybe} | No {no} |
| Keynote  |
| Workshop |

? Anything else?
___
___

-> submit

--- {#bye}

# Sorry to miss you

? Why not?
___
___
`,
  },
  {
    id: 'feedback',
    title: 'Feedback survey',
    description: 'Ratings, scales and a grid.',
    source: `---
title: How did we do?
description: Two minutes, anonymous, and genuinely read.
submit: Send feedback
confirmation: Thank you! We read every reply.
---

? Overall, how satisfied are you? *
[rating 5]

? How likely are you to recommend us to a friend? *
[scale 0..10 "Not likely" "Very likely"]

? Rate each part of the experience
[grid]
|              | Poor | Fair | Good | Great |
| Ease of use  |
| Speed        |
| Support      |

? What did you use us for?
- [ ] Work
- [ ] A side project
- [ ] Learning
- [ ] Other: ___

? What should we improve?
___
___

? May we follow up by email?
- ( ) Yes -> #contact
- ( ) No -> submit

--- {#contact}

# Thanks, one more thing

? Your email {#contact-email}
> Only used to follow up on your feedback.
[email]
`,
  },
  {
    id: 'job',
    title: 'Job application',
    description: 'File upload, validation attributes and a dropdown.',
    source: `---
title: Application: Product Engineer
description: |
  We read every application ourselves. It usually takes us **a week** to reply.
submit: Submit application
---

# About you

? Full name *
___

? Email *
[email]

? Phone number
[text placeholder="+1 555 0100" pattern="[+0-9 ()-]{6,20}"]

? Where are you based? *
[select]
- Amsterdam
- Toronto
- Remote (EU)
- Remote (Americas)

? Earliest start date
[date]

---

# Your work

? Link to something you've built *
> A repository, a demo, a design, anything you're proud of.
[url placeholder=https://]

? Resume or CV *
[file accept=".pdf,.docx" maxsize=10MB]

? Which of these have you worked with?
[checkbox min=1]
- [ ] TypeScript
- [ ] Cloudflare Workers
- [ ] SQL
- [ ] Accessibility
- [ ] Other: ___

? Years of professional experience
[number min=0 max=50 step=1]

? Why this role?
[paragraph minlength=50 maxlength=2000 placeholder="A few sentences is plenty."]
`,
  },
  {
    id: 'support',
    title: 'Support request',
    description: 'Branching: each answer leads to a different page.',
    source: `---
title: Support request
submit: Send request
confirmation: We'll get back to you within one business day.
---

--- {#start}

? What do you need help with? *
- ( ) Billing -> #billing
- ( ) A bug -> #bug
- ( ) Something else -> #other

--- {#billing}

# Billing

? Invoice number
[text placeholder="INV-1234"]

? What's the problem? *
___
___

-> submit

--- {#bug}

# Bug report

? What happened? *
___
___

? How urgent is it?
- ( ) Blocking my work
- ( ) Annoying
- ( ) Cosmetic

? Screenshot
[file accept="image/*" maxsize=5MB maxfiles=3]

-> submit

--- {#other}

# Something else

? Tell us more *
___
___
`,
  },
];

export function exampleById(id) {
  return EXAMPLES.find((e) => e.id === id) || EXAMPLES[0];
}
